import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-crm_tags_list',
  templateUrl: './crm_tags_list.component.html',
  styleUrls: ['./crm_tags_list.component.css']
})
export class CrmTagsListComponent implements OnInit {


  constructor() { }

  ngOnInit() {
  }

}
